import type { DeleteActivity } from './typings'

export const deleteActivity = (payload: number): DeleteActivity => ({
  type: 'activities/delete',
  payload,
})
